module.exports = __webpack_public_path__ + "static/media/CANBK_F1.bce36aa5.txt";